import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminCareers() {
    const [tab, setTab] = useState("vacancies");
    const [vacancies, setVacancies] = useState([]);
    const [apps, setApps] = useState([]);

    useEffect(() => {
        api.get("/vacancies").then((r) => setVacancies(r.data));
        api.get("/admin/applications").then((r) => setApps(r.data)).catch(() => {});
    }, []);

    return (
        <div className="p-8" data-testid="admin-careers">
            <h1 className="font-display text-3xl font-bold mb-1">Careers</h1>
            <div className="flex gap-1 border-b border-border mb-6">
                <button onClick={() => setTab("vacancies")} className={`px-4 py-2 text-sm font-semibold border-b-2 ${tab === "vacancies" ? "border-primary text-primary" : "border-transparent"}`}>
                    Vacancies ({vacancies.length})
                </button>
                <button onClick={() => setTab("applications")} className={`px-4 py-2 text-sm font-semibold border-b-2 ${tab === "applications" ? "border-primary text-primary" : "border-transparent"}`}>
                    Applications ({apps.length})
                </button>
            </div>
            {tab === "vacancies" ? (
                <div className="bg-white border border-border">
                    <table className="w-full text-sm">
                        <thead className="bg-muted text-left"><tr>
                            <th className="px-4 py-3">Title</th><th className="px-4 py-3">Dept</th><th className="px-4 py-3">Location</th><th className="px-4 py-3">Type</th>
                        </tr></thead>
                        <tbody>
                            {vacancies.map((v) => (
                                <tr key={v.id} className="border-t border-border">
                                    <td className="px-4 py-3 font-semibold">{v.title}</td>
                                    <td className="px-4 py-3">{v.department}</td>
                                    <td className="px-4 py-3">{v.location}</td>
                                    <td className="px-4 py-3">{v.employment_type}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="bg-white border border-border">
                    <table className="w-full text-sm">
                        <thead className="bg-muted text-left"><tr>
                            <th className="px-4 py-3">Applicant</th><th className="px-4 py-3">For</th><th className="px-4 py-3">Phone</th><th className="px-4 py-3">CV</th><th className="px-4 py-3">Status</th>
                        </tr></thead>
                        <tbody>
                            {apps.map((a) => (
                                <tr key={a.id} className="border-t border-border">
                                    <td className="px-4 py-3">
                                        <div className="font-semibold">{a.full_name}</div>
                                        <div className="text-xs text-muted-foreground">{a.email}</div>
                                    </td>
                                    <td className="px-4 py-3">{a.vacancy_title}</td>
                                    <td className="px-4 py-3 text-xs">{a.phone}</td>
                                    <td className="px-4 py-3"><a href={`${process.env.REACT_APP_BACKEND_URL}${a.cv_url}`} target="_blank" rel="noreferrer" className="text-primary font-semibold underline">View CV</a></td>
                                    <td className="px-4 py-3 capitalize">{a.status}</td>
                                </tr>
                            ))}
                            {apps.length === 0 && <tr><td colSpan="5" className="text-center py-12 text-muted-foreground">No applications yet</td></tr>}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
